<!-- BulletInfo.vue -->
<script setup lang="ts">
  import { IBulletInfoProps } from '@/types'
  import { Typography } from '@components/index'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<IBulletInfoProps>()
  const defaultIcon = 'arrow-right-square-fill'
  const onClick = props.onClick ?? (() => {})

  const handleClick = () => {
    onClick()
  }

  const text = props.data.title
  const regex =
    /(.+?)(?:R\$\s?|US\$\s?|€\s?|\$?\s?)(\d{1,3}(?:[.,]\d{3})*(?:,\d{1,2})?|\d+(?:\.\d+)?)(.+)?/g
  const matches = regex.exec(text)

  const title = matches ? matches[1] : text
  const value = matches ? matches[2] : ''
  const description = matches ? matches[3] || '' : ''
</script>

<template>
  <div class="col-12">
    <div
      class="box-wrapper"
      @click="handleClick"
    >
      <div class="box-frame d-flex flex-column justify-content-between py-4 rounded-3">
        <div class="title-frame">
          <Typography variant="bullet-info-title">{{ title }}</Typography>
          <Typography variant="bullet-info-value">{{ value }}</Typography>
          <Typography variant="bullet-info-description">{{ description }}</Typography>
        </div>
        <i
          class="icon"
          :class="loadIcon(defaultIcon)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .box-wrapper {
    cursor: pointer;

    .box-frame {
      background-color: #2d3034;
      color: #ffffff;
      height: 100%;
      position: relative;
    }

    .title-frame {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .icon {
      height: 16px;
      width: 16px;
      position: absolute;
      bottom: 25px;
      right: 25px;
    }
  }
</style>
